import { useQuery } from "@tanstack/react-query";

import { allQueryKeys } from "#app/_api/allQueryKeys";
import type { GetOutageWebData } from "#app/_api/external-bol-notification-service/get-outage-web";
import { useOutageBypass } from "#app/_ui/components/outages/use-outage-bypass";
import { retryFn } from "#app/lib/fetchClient.utils";
import { logError } from "#app/lib/logger";
import { TimeSpan } from "#app/lib/TimeSpan";

function selectPageOutageByPath({
  data,
  hasBypass,
  path,
}: {
  data: GetOutageWebData;
  hasBypass: boolean;
  path: string;
}) {
  const match = data?.pageOutages?.find?.((el) => el.path === path);
  const hasStatusMessage = !!match?.statusMessage?.trim();
  if (!match || (match.isAvailable && !hasStatusMessage)) {
    return undefined;
  }
  if (!hasBypass) {
    return match;
  }
  return { ...match, isAvailable: true };
}

export type UseQueryPageOutageData = ReturnType<
  typeof useQueryPageOutage
>["data"];

export function useQueryPageOutage({ path }: { path: string }) {
  const hasBypass = useOutageBypass();
  const result = useQuery({
    ...allQueryKeys.externalBolNotificationService.outageWeb,
    staleTime: TimeSpan.fromMinutes(1).totalMilliseconds,
    retry: retryFn(1),
    select: (data) => selectPageOutageByPath({ data, hasBypass, path }),
  });
  if (result.isError) {
    logError(result.error);
  }
  return result;
}
